<template>
  <experto-retail-loader v-if="loading"/>
  <div
    v-else
    style="width: 100%; margin: auto"
  >
    <div class="header-container">
      <PageHeader
        title="Publicaciones realizadas por equipo en ruta"
        class="my-2"
      />
      <div class="buttons-container">
        <b-button
          variant="primary"
          class="modern-btn"
          @click="goToUpload"
        >
          <i class="fa fa-upload mr-2"></i>
          Subir imágenes
        </b-button>
        <b-button
          variant="outline-primary"
          class="modern-btn"
          :disabled="loading"
          @click="refreshList"
        >
          <i class="fa fa-refresh mr-2" :class="{'fa-spin': loading}"></i>
          Actualizar
        </b-button>
        <exportable-ppt></exportable-ppt>
      </div>
    </div>
    <div style="display: flex;">
      <div class="news-feed-metrics-container">
        <news-feed-metrics/>
      </div>
      <div id="newsFeedContent" style="width: 90%;" class="m-2">
        <div style="width: 40%">
          <div v-if="newsFeedList.length > 0">
            <div
              v-for="newFeed in newsFeedList "
              :key="newFeed.id">
              <NewsCard :content="newFeed"/>
            </div>
          </div>
          <div v-else class="container">
            <p class="text"> El equipo en ruta aun no ha hecho publicaciones. Si necesitas capacitación sobre este
              módulo, contáctate con el equipo de Experto Retail o tu administrador</p>
          </div>
        </div>
      </div>
    </div>

    <div class="sticky-bottom">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        align="center"
        class="m-3"
        @change="atPageClick"
      />
    </div>
  </div>
</template>

<script>
  import {trade} from '../../../services/api/ExpertoRetail'
  import NewsCard from '@/expertoRetail/components/Trade/StorePublicationContent/NewsCard'
  import PageHeader from '@/app/shared/components/PageHeader'
  import ExportablePpt from './components/ExportablePpt'
  import NewsFeedMetrics from './components/NewsFeedMetrics'

  export default {
    name: 'StorePublicationContent',
    components: {
      NewsCard,
      PageHeader,
      ExportablePpt,
      NewsFeedMetrics
    },
    data () {
      return {
        loading: false,
        newsFeedList: [],
        rows: 0,
        currentPage: 1,
        perPage: 0
      }
    },
    created () {
      this.fetch(this.currentPage)
    },
    methods: {
      async atPageClick (event) {
        this.fetch(event)
      },
      async fetch(page) {
        this.loading = true
        this.newsFeedList = await trade.newsFeedList(page)
        if (this.newsFeedList.length > 0) {
          this.rows = this.newsFeedList ? this.newsFeedList[0]['count'] : 0
          this.perPage = this.newsFeedList ? this.newsFeedList[0]['perPage'] : 0
          this.currentPage = page
        }
        this.loading = false
      },
      goToUpload () {
        this.$router.push({ name: 'UploadImagesFeed' })
      },
      refreshList () {
        this.fetch(this.currentPage)
      }
    }
  }
</script>

<style scoped>
  .sticky-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.9);
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 80vh;
  }

  .text {
    font-size: 1.5rem;
  }
  .news-feed-metrics-container {
    width: 10%;
    height: 500px;
    margin-top: 60px;
    overflow-y: hidden; /* Hide scrollbar by default */
  }

  .news-feed-metrics-container:hover {
    overflow-y: auto; /* Show scrollbar on hover */
  }
  #newsFeedContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .modern-btn {
    padding: 0.5rem 1rem;
    font-weight: 500;
    border-radius: 8px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-size: 0.9rem;
  }

  .modern-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    padding: 0 1rem;
  }

  .buttons-container {
    display: flex;
    gap: 0.75rem;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/expertoRetail/views/trade/StorePublicationContent.vue